/**
 * Hook to retrieve lookup options for a field from metadata
 */

export interface LookupOptionsField {
  name: string;
  lookupList?: string;
  [key: string]: any;
}

export interface LookupOptionsValue {
  key: string;
  value: string;
  [key: string]: any;
}

export interface LookupOptionsLookup {
  name: string;
  values: LookupOptionsValue[];
}

export interface LookupOptionsMetadata {
  lookups?: LookupOptionsLookup[];
  [key: string]: any;
}

export const useLookupOptions = (metadata: LookupOptionsMetadata) => {
  return (field: LookupOptionsField): Array<{ key: string; value: string }> => {
    const lookup = metadata.lookups?.find((l) => l.name === field.lookupList);
    if (!lookup) {
      return [];
    }
    return lookup.values;
  };
};
